<template>

</template>
<script>
    export default {
        name: 'PanFooter',
        components:{},
        props:[],
        data () {
            return {

            };
        },
        methods: {

        },
        computed:{

        },
        mounted() {

        },
        watch:{

        }
    }
</script>
<style scoped>

</style>